import { useMemo } from 'react';
import { useMatches, type UIMatch } from 'react-router';

/** True when the active route match is the cart page (`_app.cart`), regardless of site/locale prefix. */
export function isCartRouteMatch<T = unknown>(match: UIMatch<T>): boolean {
    return match.id.includes('routes/_app.cart');
}

export function useIsCartRoute(): boolean {
    const matches = useMatches();

    return useMemo(() => matches.some(isCartRouteMatch), [matches]);
}
